import React, { ElementType } from "react";
import './index.scss';
import { Dialog } from '@headlessui/react';
import Close from '../../atoms/icon/icons/Close';
import Icon, { IconName } from "../../atoms/icon";

interface ModalProps {
    children: React.ReactNode;
    isOpen: boolean;
    isUserLoggedIn?: boolean;
    setIsOpen: (open: boolean) => void;
    title: string;
    className?: string;
    titleTag: ElementType;
    icon?: IconName;
}

const Modal = ({
    children,
    isOpen,
    setIsOpen,
    title,
    isUserLoggedIn,
    className,
    titleTag,
    icon
}: ModalProps) => {
    const baseClassName = 'm-modal';

    return (
        <Dialog className={`${baseClassName} ${isUserLoggedIn ? '-userLoggedIn' : ''} ${className ?? ''}`} open={isOpen} onClose={() => setIsOpen(false)} as="div">
            <div className={`${baseClassName}__wrapper container-lg`}>
                <Dialog.Overlay className={`${baseClassName}__overlay`} />
                <div className={`${baseClassName}__content`}>
                    <div className={`position-relative`}>
                        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                        <button aria-label={`${window.sv_resource.get('711')}`} className={`${baseClassName}__closeButton`} onClick={() => setIsOpen(false)} type="button"><Close /></button>
                        <div className={`d-flex align-items-center mb-3`}>
                            { icon && (
                                <Icon name={icon} className={`me-2`}/>
                            )}
                            <Dialog.Title className={`${baseClassName}__title mb-0`} as={titleTag}>{title}</Dialog.Title>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

Modal.defaultProps = {
    isUserLoggedIn: false,
    titleTag: 'h1',
};

export default Modal;
